import { menuCodeMap } from '../config/menuCodeMap';

/**
 * Where an Ask Patch "Open …" button goes.
 *
 * The API decides WHICH screens a user may be offered (api/utils/
 * assistantScreens.js, mirroring the sidebar); this file only turns a screen
 * key into a route, so routes stay next to the router. Menu screens reuse
 * menuCodeMap — the table the sidebar itself draws from — and the rest are
 * listed here. A key with no route returns null and no button is drawn.
 */

const enc = encodeURIComponent;

const ROUTES = {
  // Not menus of their own, or menus whose key differs from the API's.
  handovers: '/manager/handovers',
  care_packages: '/manager/care-packages',
  messages: '/manager/messages',
  audit_actions: '/manager/audits-policies/actions',
  policies: '/manager/audits-policies/policies',
  admin_dashboard: '/dashboard',
  organisations: '/organizations',
  plans: '/plans',
  menus: '/menus',
  mailbox: '/mailbox',

  // One record. The resident page reads ?tab= (see utils/reminderLinks.js);
  // the policy library opens its viewer from ?view=; Recruitment selects a
  // candidate from ?candidate= (and the History list from ?view=history).
  resident: ({ id, tab }) => `/manager/residences/${enc(id)}${tab ? `?tab=${enc(tab)}` : ''}`,
  staff_member: ({ id }) => `/manager/staffs/${enc(id)}/view`,
  candidate: ({ id, view }) => `/manager/recruitment?candidate=${enc(id)}${view === 'history' ? '&view=history' : ''}`,
  audit: ({ id }) => `/manager/audits-policies/audits/${enc(id)}`,
  policy: ({ id }) => `/manager/audits-policies/policies?view=${enc(id)}`,
};

/** The route for one action from the API, or null when there is nowhere to go. */
export const assistantActionHref = (action, { isDomiciliary = false } = {}) => {
  if (!action || action.type !== 'open' || !action.screen) return null;
  const { screen, params = {} } = action;

  // A domiciliary service's Rota is the visit schedule (as in Sidebar.js).
  if (screen === 'duty_roster') return isDomiciliary ? '/manager/domiciliary-schedule' : menuCodeMap.duty_roster.route;

  const route = ROUTES[screen];
  if (typeof route === 'function') return params.id ? route(params) : null;
  if (route) return route;
  return menuCodeMap[screen]?.route || null;
};
